import templateUrl from "./settings-edit.html";
import { assign } from "lodash";

export const settingsEditComponent = {
  templateUrl,

  bindings: {
    details: "<",
  },

  controller: class SettingsEditComponent {
    constructor(
      $scope,
      $state,
      $stateParams,
      $timeout,
      toastr,
      ModalService,
      VideoUrlService,
      SettingsService,
      CompareObjectService
    ) {
      "ngInject";

      this.$scope = $scope;
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.$timeout = $timeout;
      this.toastr = toastr;
      this.modalService = ModalService;
      this.settingsService = SettingsService;
      this.VideoUrlService = VideoUrlService;
      this.compareObjectService = CompareObjectService;
    }

    $onInit() {
      this.selectedTab =
        this.$stateParams.settingName || this.details.settings[0].name;
      const formatSettingValues = (title, setting) => {
        return { title, name: setting.name, values: setting.value };
      };
      this.details.settings = this.details.settings.map((setting) => {
        switch (setting.name) {
          case "spouseChecklistVideoUrl":
            return assign(
              formatSettingValues("Spouse Checklist Video", setting),
              { isVideoURL: true }
            );
          case "homeVideoUrl":
            return assign(formatSettingValues("Home Video", setting), {
              isVideoURL: true,
            });
          case "timelineVideoUrl":
            return assign(formatSettingValues("Timeline Video", setting), {
              isVideoURL: true,
            });
          case "emailNotifications":
            return assign(
              formatSettingValues("Inactivity Reminder Email", setting),
              { isInactivityReminderEmail: true }
            );
          case "weeklyNewsletter":
            return assign(formatSettingValues("Weekly Newsletter", setting), {
              isWeeklyNewsletter: true,
            });
        }
      });
    }

    onSubmit() {
      // copy the original details object
      const settings = angular.copy(this.details);

      const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(
        this.savedData,
        settings,
        false
      );
      if (this.details.url) {
        const isVideoUrlValid = this.VideoUrlService.isVideoUrlValid(
          this.details.url
        );
        this.hasVideoValidationError = !isVideoUrlValid;
      }
      if (!this.hasVideoValidationError) {
        this.hasVideoValidationError = false;
      }
      if (isUpdated) {
        if (
          this.$scope.editSettingsForm &&
          this.$scope.editSettingsForm.$invalid
        ) {
          this.disableButtons = false;
        } else {
          this.disableButtons = true;
          this.settingsService.updateSettingDetails(settings).then((_) => {
            this.$state.go("settings");
            this.toastr.success("Settings updated successfully");
            this.disableButtons = false;
          });
        }
      } else {
        this.$state.go("settings");
        this.toastr.success("Nothing to update");
      }
    }

    onCancel() {
      const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(
        this.savedData,
        this.details,
        false
      );

      if (isUpdated) {
        this.modalService.open({
          details: {
            bodyMessage: "Changes done will be reverted. Continue?",
          },

          buttons: [
            {
              name: "No",
            },
            {
              name: "Yes",
              isPrimary: true,
              action: onSubmit.bind(this),
            },
          ],
        });

        function onSubmit() {
          this.$state.go("settings");
        }
      } else {
        this.$state.go("settings");
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/settings/settings-edit/settings-edit.component.js